<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="32%" append-to-body :before-close="resetForm">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="登录账号" prop="username">
        <el-input v-model="form.username" placeholder="请输入登录账号" :disabled="isEdit"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input v-model="form.name" placeholder="请输入真实姓名"></el-input>
      </el-form-item>
      <div style="color:#F56C6C; margin-left:80px;" v-if="!isEdit">登录账号提交后不能修改，请谨慎设置</div>
      <el-form-item label="平台" prop="platform">
        <el-select v-model="form.platform" placeholder="请选择平台" style="width:100%;" @change="changePlatform" :disabled="isEdit">
          <el-option v-for="item in platformList" :key="item.id" :label="item.label" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="isSponsor">
        <el-form-item label="主办方名称" prop="platform">
          <el-select v-model="form.sponsorId" filterable placeholder="请选择主办方" style="width:100%;" :disabled="isEdit" @change="changeSponsor">
            <el-option v-for="item in sponsorList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template v-if="isSponsor">
        <el-form-item label="邮箱">
          <el-input v-model="email" disabled></el-input>
        </el-form-item>
      </template>
      <el-form-item label="角色">
        <el-checkbox-group v-model="checkedRoleList">
          <el-checkbox v-for="item of roleList" :key="item.id" :label="item.id">{{item.title}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="resetForm">取 消</el-button>
      <el-button type="primary" @click="confirmHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import RoleService from '@/services/system/role';

import AccountService from '@/services/system/account';
import SponsorService from '@/services/user/sponsor';
import { usernameReg } from '@/constant'
export default {
  props: {
    platformList: {
      type: Array,
      default: () => [],
    }
  },
  data () {
    const validateUserName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入用户名"));
      } else if (!usernameReg.test(value)) {
        callback(new Error("格式化错误(长度在6-20之间，只能包含数字、字符、_)"));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      title: '',
      form: {
        username: '',
        name: '',
        platform: '',
        sponsorId: '',
      },
      email: '',
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { required: true, validator: validateUserName, trigger: "blur" }
        ],
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        platform: [
          { required: true, message: '请选择平台', trigger: 'blur' },
        ],
      },
      isEdit: false,
      currentRowId: 0,
      sponsorList: [],
      // platformList: [],
      roleList: [],
      checkedRoleList: [],
      isSponsor: false,
    }
  },
  methods: {
    openModal (rowData = {}) {
      this.email = '';
      if (Object.keys(rowData).length) {
        this.title = '编辑账号';
        this.form = {
          username: rowData.username,
          name: rowData.name,
          platform: rowData.platform,
          sponsorId: rowData.sponsorId,
        }
        this.isEdit = true;
        this.currentRowId = rowData.id;
        this.initAccountRoleList(rowData.id);
        this.changePlatform(rowData.platform);
        this.changeSponsor(rowData.sponsorId);
      } else {
        this.isEdit = false;
        this.title = '新增账号';
        this.checkedRoleList = [];
        this.form = {
          username: '',
          name: '',
          platform: '',
          sponsorId: '',
        }
      }
      this.dialogVisible = true;
    },
    // 获取全部的角色
    async initRoleList () {
      const { code, message, result: { data } } = await RoleService.roleListApi({ pageSize: 100 });
      if (Object.is(code, 0)) {
        this.roleList = data;
      } else {
        console.error('获取角色列表失败', message);
      }
    },
    // 获取已经选择的角色
    async initAccountRoleList (accountId) {
      const { code, message, result } = await AccountService.accountRoleListApi(accountId);
      if (Object.is(code, 0)) {
        this.checkedRoleList = result.map(item => item.roleId);
      } else {
        console.log('获取授权角色失败', message);
      }
    },

    // 获取全部的主办方
    async initSponsorList () {
      const { code, message, result: { data } } = await SponsorService.sponsorListApi({ pageSize: 1000 })
      if (Object.is(code, 0)) {
        this.sponsorList = data;
      } else {
        console.error('获取主办方列表失败', message);
      }
    },
    // 切换平台
    changePlatform (val) {
      if (Object.is(val, 1)) {
        this.isSponsor = true;
      } else {
        this.isSponsor = false;
      }
    },
    // 切换主办方
    async changeSponsor (val) {
      if (!val) return;
      const { code, result } = await SponsorService.sponsorApi(val);
      if (Object.is(code, 0)) {
        this.email = result.email;
      } else {
        console.log('获取失败');
      }
    },
    confirmHandle () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const postData = {
            ...this.form,
            roles: this.checkedRoleList.toString(),
          };
          if (this.isEdit) {
            const { code, message } = await AccountService.updateAccountApi(this.currentRowId, postData)
            if (Object.is(code, 0)) {
              this.$message.success(message);
              this.$emit('loadData');
              this.resetForm();
            } else {
              this.$message.error(message);
            }
          } else {
            const { code, message } = await AccountService.createAccountApi(postData);
            if (Object.is(code, 0)) {
              this.$message.success(message);
              this.$emit('loadData');
              this.resetForm();
            } else {
              this.$message.error(message);
            }
          }
        } else {
          return false;
        }
      })
    },
    resetForm () {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    }
  },

  mounted () {
    this.initRoleList();
    // this.initPlatform();
    this.initSponsorList();
  }
}
</script>

<style lang="scss" scoped>
</style>